<template>
<b-container fluid style="margin-top:60px;">
<b-col class="text-center" style="margin-bottom:30px; color:black;">
  <b-card-group >
    <b-row>
    <div v-for='(nav,index) in navs' v-bind:key="nav.nav" class="col-2">
      <b-card v-if="index %2 === 0" img-top style="border-radius: 10px; min-height: 320px;border-bottom-width: 15px; border-bottom-color: #ffcc00;" >
        <b-card-img
            :title="nav.name"
            style="border-radius: 10px; padding-bottom:10px;" 
            :src="nav.image"
            height="160"
            width="40"
            img-alt="Image"
            v-on:click="$router.push('/editors/component/' + nav.nav)">
        </b-card-img>
        <b-card-title> {{ nav.name }}</b-card-title>
        <b-card-text>{{nav.desc}}</b-card-text>
      </b-card>
      <b-card v-if="index %2 === 1" img-top style="border-radius: 10px; min-height: 320px;border-bottom-width: 15px; border-bottom-color: #660032;" >
        <b-card-img
            :title="nav.name"
            style="border-radius: 10px; padding-bottom:10px;"
            :src="nav.image"
            height="160"
            width="40"
            img-alt="Image"
            v-on:click="$router.push('/editors/component/' + nav.nav)">
        </b-card-img>
        <b-card-title> {{ nav.name }}</b-card-title>
        <b-card-text>{{nav.desc}}</b-card-text>
      </b-card>
      
      <br/>
    </div>
    </b-row>
  </b-card-group>
</b-col>
</b-container>
</template>

<style type="text/css" scoped>
  .hovering {
    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.5) !important;
  }

	.nav-comp{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	.nav-comp .box{
		flex: 20%;
		/*padding: 1em 1em;*/
		text-align: center;
		background: white;
		border-radius: 10px;
		transition: all 0.2s ease;
		cursor: pointer;
    color:black;
	}
	.nav-comp .box:hover{
		background: lightgrey;
		color: black;
	}
</style>

<script type="text/javascript">
	export default{
		data: function(){
			return {
        isActive: false,
        bgColor:"red",
				navs : [
					{
						name: "Gallery",
						nav: "gallery",
						desc: "Collection of photos",
            image:"navigation/Gallery.png"
					},
					{
						name: "Biography",
						nav: "biography",
						desc: "Highlight an individual",
            image:"navigation/Biography.png"
					},
					{
						name: "Image",
						nav: "image",
						desc: "Single image",
            image: "navigation/Image.png"
					},
					{
						name: "Infographic 1",
						nav: "infographic1",
						desc: "Single image with popup",
            image:"navigation/infographic1.png"
					},
					{
						name: "Infographic 2",
						nav: "infographic2",
						desc: "Sliders",
            image:"navigation/infographic2.png"
					},
					{
						name: "Infographic 3",
						nav: "infographic3",
						desc: "Graphs and Charts",
            image:"navigation/infographic3.png"
					},
					{
						name: "Infographic 4",
						nav: "infographic4",
						desc: "Map with markers",
            image:"navigation/infographic4.png"
					},
					{
						name: "Infographic 5",
						nav: "infographic5",
						desc: "Positions and prompts",
            image:"navigation/Infographic5.png"
					},
					//{
					//	name: "Infographic 6",
					//	nav: "infographic6",
					//	desc: "Image with heading and pop-up tags",
          //  image:"navigation/Infographic6.png"
					//},
          {
            name: "Interactive Map",
            nav: "map",
            desc: "Map with push pins",
            image:"navigation/Infographic6.png"
          },
					{
						name: "Jigsaw",
						nav: "jigsaw",
						desc: "Jigsaw puzzle",
            image:"navigation/Jigsaw.png"
					},
					{
						name: "Timeline",
						nav: "timeline",
						desc: "Create a timeline",
            image:"navigation/Timeline.png"
					},
					{
						name: "Vocabulary",
						nav: "vocabulary",
						desc: "Vocabulary drag and drop",
            image:"navigation/Vocabulary.png"
					},
					{
            name: "Lesson Plan",
            nav: "LessonPlan",
            desc: "Create lesson plan/lesson module",
            image:"navigation/LessonPlan.png"
          },
          {
            name: "Video",
            nav: "video",
            desc: "Upload video",
            image:"navigation/Video.png"
          },
          {
            name: "Audio",
            nav: "audio",
            desc: "Upload MP3 audio file",
            image:"navigation/Audio.png"
          },
          {
            name: "Featured",
            nav: "Featured",
            desc: "Set featured content for home page",
            image:"navigation/Featured.png"
          },
          {
            name: "PDF",
            nav: "PDF",
            desc: "Upload single PDF document",
            image:"navigation/Pdf.png"
          },
           // {
           //     name:"VR",
           //     nav:"VR",
           //     desc:"VR Content",
           //     image:""
           // }
				]
			}
		},
    methods: {
      mouseOver : function() {
        this.isActive = true;
      },
      mouseLeave : function() {
        this.isActive = false;
      }
    }
	}
</script>